import React, { useState } from 'react';
import Link from 'next/link';

export default function ListCoupons({ airports }) {
  const [showAll, setShowAll] = useState(false);
  const displayedAirports = showAll
    ? airports.result
    : airports.result.slice(0, 18);

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 w-full mt-6">
        {displayedAirports.map((airport) => (
          <Link
            key={airport.airport_id}
            className="md:text-lg text-primary font-bold"
            href={`/parking-coupons/${airport.airport_initials}`}
            title={`${airport.airport_name} Coupons`}
          >
            {airport.airport_name} ({airport.airport_initials})
          </Link>
        ))}
      </div>
      <div className="text-center mt-4">
        <button
          onClick={() => setShowAll(!showAll)}
          className="px-4 py-2 text-primary font-semibold rounded-md hover:bg-primary hover:text-white"
        >
          {showAll ? 'Show Less' : 'Show All Airports'}
        </button>
      </div>
    </div>
  );
}
